import React, {useEffect, useState} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import styled from '@emotion/styled';

import ProductItem from '../ProductItem';
import SearchBar from './SearchBar';
import PaginationComponent from '../shared/PaginationComponent';

import {getBrands, getCatalogue, getCategories} from '../../network';
import OverlayComponent from '../shared/OverlayComponent';

import {enableLoading, disableLoading} from '../../redux/actions/LoadingActions';
import LoadingComponent from '../shared/LoadingComponent';

const Layout = styled.div`
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    
    margin-top: 5rem;
    margin-bottom: 6rem;

    @media only screen and (max-width: 425px) {
       margin-top: 0;
    }
`;

const BreadCrumb = styled.span`
    display: flex;
    align-items: center;

    position: relative;

    font-size: var(--font-18);
    line-height: var(--font-18);

    color: var(--color-gray-700);

    > img {
        margin-left: var(--space-20);
        margin-right: var(--space-20);
    }
    @media only screen and (max-width: 768px) {
        padding-left: 2rem;
       
     }
    @media only screen and (max-width: 425px) {
        display:none;
       
     }
`;

const Badge = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    padding: var(--space-6) var(--space-8);
    font-size: var(--font-14);
    line-height: var(--font-14);

    color: var(--color-white);

    background: var(--company-dark);

    border-radius: 0.25rem;

    > img {
        width: var(--space-8);
        height: var(--space-8);

        margin-left: var(--space-8);

        cursor: pointer;
    }
`;

const InnerContent = styled.div`
    display: grid;
    grid-template-columns: 16.75rem auto;
    
    grid-gap: var(--space-56);

    @media only screen and (max-width: 768px) {
        grid-template-columns: 1fr;
     }
`;

const FilterSection = styled.div`
    display: flex;
    flex-direction: column;

    > .header {
        margin-bottom: var(--space-24);
        
        color: var(--color-gray-800);
        
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-20);
        line-height: var(--font-20);
    }
    
    > .option {
        width: fit-content;
        
        margin-left: var(--space-16);
        margin-bottom: var(--space-24);
        
        color: var(--color-gray-800);
        
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-16);
        line-height: var(--font-16);

        transition: color 0.3s ease-in-out;
        
        cursor: pointer;
        
        &:hover {
            color: var(--color-gray-500);
        }

        &:last-of-type {
            margin-bottom: 0;
        }
    }
    @media only screen and (max-width: 768px) {
       display:none;
    }
`;

const ResultsSection = styled.div`
    display: flex;
    flex-direction: column;
    
    > .results-details-panel {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        
        margin-bottom: var(--space-32);
    }
    @media only screen and (max-width: 1100px) {
        width: 40rem;
    }
    @media only screen and (max-width: 800px) {
        width: 20rem;
        .results-details-panel{
            width: 30rem;
        }
    }
 
    @media only screen and (max-width: 400px) {
    }
 
`;

const FilterText = styled.div`
    position: relative;
    
    font-style: normal;
    font-weight: normal;
    
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    > .query {
        margin-right: var(--space-8);
        color: var(--color-neutral-gray-900);
    }
    
    > .results {
        color: var(--color-neutral-gray-600)
    }
`;

const SortContainer = styled.div`
    > span {
        font-style: normal;
        font-weight: normal;
        
        margin-right: var(--space-8);
        
        font-size: var(--font-16);
        line-height: var(--font-16);
        
        color: #2d2d2d;
    }
    
    > select {
        padding: 0.5rem 1.25rem;
        
        background: white;
        
        color: var(--color-neutral-gray-900);
        font-size: var(--font-16);
        line-height: var(--font-16);
        
        border: 1px solid var(--color-neutral-gray-400);
        box-sizing: border-box;
        border-radius: 0.375rem;
        -webkit-appearance:none;
        background-image: url(/icons/chevron.svg);
        background-repeat: no-repeat;
        background-position-x: 7rem;
        background-position-y:center;
    }
    @media only screen and (max-width: 425px) {
        display:none;
    }
`;

const FilterContainer = styled.div`
   

    @media only screen and (max-width: 425px) {
    
        > select {
            display:flex;
            padding: 0.5rem 0.75rem;
            
            background: white;
            
            color: var(--color-neutral-gray-900);
            font-size: var(--font-16);
            line-height: var(--font-16);
            
            border: 1px solid var(--color-neutral-gray-400);
            box-sizing: border-box;
            border-radius: 0.375rem;
        }
    }
`;

const ResultsContainer = styled.div`
    display: grid;
    grid-gap: 1.25rem;
    grid-template-columns: 1fr 1fr 1fr;

    @media only screen and (max-width: 1100px) {
       grid-template-columns: 1fr auto;
     }
     @media only screen and (max-width: 425px) {
        grid-template-columns: 1fr;
        grid-gap: var(--space-24);
      }
`;

const SearchContainer = styled.div`
    width: auto;
    margin-top: 2.5rem;
`;

const PaginationContainer = styled.div`
    width: 10rem;
    
    margin-top: var(--space-40);
`;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    
    margin-top: var(--space-32);
    margin-bottom: var(--space-40);
    
    background: var(--color-gray-400);
    @media only screen and (max-width: 800px) {
        width:100%;
       
     }
     @media only screen and (max-width: 500px) {
        width:100%;
       
     }
`;

function SearchResults(props) {
    const [width, setWidth] = useState(768);
    const [display, setDisplay] = useState(false);
    const [item, setItem] = useState({
        product: '',
        image: '',
        media: ''
    });

    const [loading, setLoading] = useState(false);

    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [brandId, setBrandId] = useState('');
    const [brandName, setBrandName] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(12);
    const [pageCount, setPageCount] = useState(1);
    const [totalResultsCount, setTotalResultsCount] = useState(0);
    const [currentResultsCount, setCurrentResultsCount] = useState(0);
    const [canvasWidth, setCanvasWidth] = useState(0);

    useEffect(() => {
        handleResize();
    });

    const handleResize = () => {
        console.log('resized to: ', window.innerWidth, 'x', window.innerHeight);
        setCanvasWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        const retrieveCategories = async () => {
            const result = await getCategories();
            setCategories([...result]);
        };
        const retrieveBrands = async () => {
            const result = await getBrands();
            setBrands([...result]);
        };
        retrieveCategories();
        retrieveBrands();


    }, []);


    useEffect(() => search(searchText, categoryId, brandId), [searchText, categoryId, brandId, currentPage]);

    const search = (searchText, category, brand) => {
        setLoading(true);

        getCatalogue(searchText, category, brand, currentPage, pageLimit)
            .then(result => {
                setProducts([...result.data]);
                setCurrentResultsCount(result.results);
                setTotalResultsCount(result.total);
                setPageCount(Math.ceil(result.total / pageLimit));
            })
            .catch(error => console.error(error))
            .finally(() => setLoading(false));
    };

    const debouncedSearchText = _.debounce(query => setSearchText(query), 400);

    const onSearchTextChange = e => {
        const value = e.target.value.trim();
        debouncedSearchText(value);
    };

    const changePage = direction => {
        if (currentPage === 1 && direction < 0) return;
        if (currentPage === pageCount && direction > 0) return;

        setProducts([]);
        setCurrentPage(currentPage + (direction));
    };

    const handleCategoryChange = e => {
        const {value} = e.target;
        searchCategoryId(value);
    };

    const searchCategoryId = value => {
        if (value) {
            const category = categories.find(element => element._id === value);
            setCategoryName(category.name);
        } else setCategoryName(value);
        setCategoryId(value);
    };

    const searchBrandId = value => {
        if (value) {
            const brand = brands.find(element => element._id === value);
            setBrandName(brand.name);
        } else setBrandName(value);
        setBrandId(value);
    };

    const filteredCategorySpecialities = categories.filter(category => category.type === 'speciality' && category.product_count > 0);
    const filteredCategoryItems = categories.filter(category => category.type === 'item' && category.product_count > 0);
    const filteredBrands = brands.filter(brand => brand.product_count > 0);

    return (
        <>
            {loading ?
                <LoadingComponent/>
                :
                <Layout>
                    <OverlayComponent display={display} setDisplay={setDisplay} item={item}/>
                    <BreadCrumb>
                        Products
                        {categoryName && <><img src="/icons/chevron_right.svg"/>{categoryName}</>}
                        {brandName && <><img src="/icons/chevron_right.svg"/><Badge>{brandName}<img src="/icons/close.svg" onClick={() => searchBrandId('')}/></Badge></>}
                        {searchText && <><img src="/icons/chevron_right.svg"/><Badge>"{searchText}"<img src="/icons/close.svg" onClick={() => setSearchText('')}/></Badge></>}
                    </BreadCrumb>
                    <SearchContainer>
                        <SearchBar
                            categories={categories}
                            selectedCategory={categoryId}
                            categoryChange={handleCategoryChange}
                            onSearchTextChange={onSearchTextChange}
                        />
                    </SearchContainer>
                    <Divider/>
                    <InnerContent>
                        <FilterSection>
                            {
                                filteredCategorySpecialities.length !== 0 && <>
                                    <span className="header">Medical Specialities</span>
                                    {
                                        filteredCategorySpecialities.map((category, index) => <span
                                                className="option"
                                                key={`CategorySpecialityOption_${index}`}
                                                onClick={() => searchCategoryId(category._id)}
                                            >
                                            {category.name} ({category.product_count || 0})
                                        </span>
                                        )}
                                    <Divider/>
                                </>
                            }

                            {
                                filteredCategoryItems.length !== 0 && <>
                                    <span className="header">Item Type</span>
                                    {
                                        filteredCategoryItems.map((category, index) => <span
                                                className="option"
                                                key={`CategoryItemOption_${index}`}
                                                onClick={() => searchCategoryId(category._id)}
                                            >
                                            {category.name} ({category.product_count || 0})
                                        </span>
                                        )}
                                    <Divider/>
                                </>
                            }

                            {
                                filteredBrands.length !== 0 && <>
                                    <span className="header">Brands</span>
                                    {
                                        filteredBrands.map((brand, index) => <span
                                                className="option"
                                                key={`BrandOption_${index}`}
                                                onClick={() => searchBrandId(brand._id)}
                                            >
                                            {brand.name} ({brand.product_count || 0})
                                        </span>
                                        )}
                                </>
                            }
                        </FilterSection>
                        <ResultsSection>
                            <div className="results-details-panel">
                                <FilterText>
                                    {searchText && <span className="query">"{searchText}"</span>}
                                    <span className="results">
                                        {
                                            categoryName || searchText
                                                ? `(${(pageLimit * (currentPage - 1)) + 1}-${((pageLimit * (currentPage - 1)) + 1) + (currentResultsCount - 1)} of ${totalResultsCount} Results)`
                                                : `no filters applied (${(pageLimit * (currentPage - 1)) + 1}-${((pageLimit * (currentPage - 1)) + 1) + (currentResultsCount - 1)} of ${totalResultsCount} Results)`
                                        }
                                    </span>
                                </FilterText>
                                {/*<SortContainer>*/}
                                {/*    <span>Sort By:</span>*/}
                                {/*    <select>*/}
                                {/*        <option value="1">Relevance</option>*/}
                                {/*    </select>*/}
                                {/*</SortContainer>*/}
                            </div>

                            {canvasWidth < 700 ?
                                <ResultsContainer>
                                    {
                                        products.map((product, index) => <ProductItem
                                                key={index}
                                                product={product}
                                                itemSmall={true}
                                                onClick={() => console.log(product.id)}
                                            />
                                        )
                                    }
                                </ResultsContainer>
                                :
                                <ResultsContainer>
                                    {
                                        products.map((product, index) => <ProductItem
                                                setDisplay={setDisplay}
                                                setItem={setItem}
                                                key={index}
                                                product={product}
                                                onClick={() => console.log(product.id)}
                                            />
                                        )
                                    }
                                </ResultsContainer>
                            }

                            <PaginationContainer>
                                <PaginationComponent
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    pageBack={() => changePage(-1)}
                                    pageNext={() => changePage(1)}
                                />
                            </PaginationContainer>
                        </ResultsSection>
                    </InnerContent>
                </Layout>
            }
        </>
    );
}

const mapStateToProps = (state,props) => ({
    loading: state.loading,
    setDisplay: props.setDisplay
});
const mapDispatchToProps = {
    enableLoading,
    disableLoading
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);
